import { Box, HStack } from "@chakra-ui/react";
import type { Messages } from "../../../../../../../../core/api";
import AddressAutocompleteInput from "../../../../../../../office-branch/components/AddressAutocompleteInput";
import { EntityProfileSummaryRow as SummaryRow } from "../../../../../../../entityProfileModal/components/EntityProfileSummary";
import type { PatientProfileDisplayData } from "../../../../../../patientProfileModal.mocks";
import type { PatientProfilePatient } from "../../../../../../patientProfileModal.types";
import { SummaryAddressActionRow } from "./PersonalDetailsRows";
import EntityModalButton from "../../../../../../../entityProfileModal/components/EntityModalButton";

type AddressAutocompleteDraft = {
  addressText: string;
  components: Messages["AddressComponents"];
};

type UpdatePrimaryAddressMutation = {
  isPending: boolean;
  mutate: (draft: AddressAutocompleteDraft) => void;
};

export function PersonalDetailsAddressRows(props: {
  activeField: string | null;
  addressAutocompleteDraft: AddressAutocompleteDraft | null;
  displayData: PatientProfileDisplayData;
  isEditing: boolean;
  patient: PatientProfilePatient;
  updatePrimaryAddressMutation: UpdatePrimaryAddressMutation;
  onActivateAddress: () => void;
  onCancelField: () => void;
  onCustomizeAddress: () => void;
  onSetAddressAutocompleteDraft: (draft: AddressAutocompleteDraft | null) => void;
}) {
  return (
    <>
      <SummaryRow
        hideBorderBottom={props.isEditing}
        isClickable={props.isEditing}
        isHighlighted={props.activeField === "address"}
        label="Address"
        value={props.displayData.addressText}
        onClick={props.isEditing ? props.onActivateAddress : undefined}
      />
      {props.activeField === "address" ? (
        <SummaryAddressActionRow onCustomizeAddress={props.onCustomizeAddress}>
          <HStack spacing={2}>
            <Box flex="1 1 auto" minW={0}>
              <AddressAutocompleteInput
                addressText={props.displayData.addressText}
                value={props.patient.address?.components ?? null}
                onChange={(addressText, components) =>
                  props.onSetAddressAutocompleteDraft({ addressText, components })
                }
                onClear={() => props.onSetAddressAutocompleteDraft(null)}
              />
            </Box>
            <EntityModalButton
              isIconOnly
              aria-label="Save Address"
              disabled={props.addressAutocompleteDraft === null}
              iconClassName="fa fa-check"
              isLoading={props.updatePrimaryAddressMutation.isPending}
              kind="blue"
              size="xs"
              style={{ flexShrink: 0 }}
              title="Save address"
              onClick={() => {
                if (props.addressAutocompleteDraft !== null) {
                  props.updatePrimaryAddressMutation.mutate(props.addressAutocompleteDraft);
                }
              }}
            />
            <EntityModalButton
              isIconOnly
              aria-label="Cancel Address"
              iconClassName="fa fa-times"
              kind="white"
              size="xs"
              style={{ flexShrink: 0 }}
              title="Cancel"
              onClick={props.onCancelField}
            />
          </HStack>
        </SummaryAddressActionRow>
      ) : props.isEditing ? (
        <SummaryAddressActionRow onCustomizeAddress={props.onCustomizeAddress} />
      ) : null}
    </>
  );
}
